// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607090904/js/" + chunkId + "." + {"44":"a6c2ba3c","225":"14d8c49d","481":"d9b3b263","486":"900ba23c","770":"eff19ea7"}[chunkId] + ".0.29363025263053744.chunk.js";
};